<template>
    <fade-transition :delay="delay" :duration="{enter:500}">
        <div v-show="show" :class="classes">
            <div v-if="contact.title.length" class="content__sectionTitle">
                {{contact.title}}
            </div>

            <div class="content__info">
                <ul class="content__listWrapper">
                    <li v-for="content_ in contact.content" class="content__list" v-html="content_"></li>
                </ul>
            </div>
        </div>
    </fade-transition>
</template>

<script>
    export default {
        props: [
            'contact',
            'delay',

        ],
        data() {
            return {
                show: false,
            }
        },
        computed: {
            classes() {
                return [
                    //'content__section content__section-generalInfo',
                    'content__section content__section-generalInfo',
                    {'content__section-withTitle': this.contact.title.length},
                ]
            },
        },
        mounted() {
            this.show = true
        },
        methods: {
        }
    }
</script>
